import setRemarketingTag from './setRemarketingTag';
import track from './track';

export default ({ category, hideIntercom, name, remarketingTag, traits }) => (
  dispatch,
  _,
  { segment },
) =>
  segment.onUserIdentified(mixpanel => {
    // https://mixpanel.com/blog/2015/01/06/community-tip-tracking-first-time-users
    // Register a qsuper-property to track "First time" users.
    // It will be stored in cookies, and it doesn't require any HTTP requests to MixPanel.
    // All next events of the user will include this super-property.
    dispatch(
      track('page', {
        traits: {
          name,
          category,
          ...traits,
        },
        options: {
          Intercom: {
            hideDefaultLauncher: hideIntercom,
          },
        },
      }),
    );

    if (mixpanel) {
      mixpanel.register({ 'First Time': 'FALSE' });
    }

    if (remarketingTag) {
      dispatch(setRemarketingTag(remarketingTag));
    }
  });
